function factory({ window, document, thn }) {
    const engine = {};
    /**
         * @memberOf module:bs_1046802
         * @see {@link onStateChange}
         *
         * @param {object} ctx - The context object.
         */
    engine.onStateChange = thn.debounce(() => {
        thn.pageCheck();
    }, 500);
    /**
         * @memberOf module:bs_1046802
         * @see {@link language_check}
         *
         * @param {object} ctx - The context object.
         */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            const lang = document.querySelector('.selector-lng[aria-current="page"]')?.textContent;
            if (lang) {
                resolve(lang);
                return;
            }
            reject('no_language');
        });
    };
    return engine;
}

export { factory };
